var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.416 18.791C22.3022 18.6046 22.1304 18.4606 21.927 18.381C15.5465 15.8737 8.45351 15.8737 2.073 18.381C1.86986 18.461 1.69824 18.6049 1.584 18.791C0.0450008 21.317 0.100001 21.2 0.0710008 21.3C-0.104375 21.8602 0.0631384 22.4712 0.499683 22.8637C0.936228 23.2561 1.56157 23.3578 2.1 23.124C5.23492 21.8215 8.60592 21.1834 12 21.25C15.3941 21.1836 18.765 21.8217 21.9 23.124C22.4384 23.3578 23.0638 23.2561 23.5003 22.8637C23.9369 22.4712 24.1044 21.8602 23.929 21.3C23.9 21.191 23.956 21.318 22.416 18.791Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.337 16.566C18.3337 15.5274 15.1778 14.9981 12 15C8.8222 14.9977 5.66636 15.5266 2.663 16.565C2.51015 16.6177 2.34124 16.5933 2.20961 16.4994C2.07799 16.4055 1.9999 16.2537 2 16.092V12.75C2.00613 7.78133 5.65425 3.56841 10.571 2.85201C10.8168 2.81673 10.9995 2.60635 11 2.358V1.75C11 1.19771 11.4477 0.75 12 0.75C12.5523 0.75 13 1.19771 13 1.75V2.358C13.0015 2.60561 13.1839 2.81485 13.429 2.85001C18.3463 3.56691 21.9944 7.78073 22 12.75V16.093C22.0001 16.2547 21.922 16.4064 21.7904 16.5003C21.6588 16.5942 21.4899 16.6187 21.337 16.566ZM7.2 8.51102C6.78337 8.64203 6.49997 9.02826 6.5 9.465V11.38C6.49985 11.6919 6.64526 11.9861 6.89318 12.1753C7.14111 12.3646 7.46315 12.4273 7.764 12.345C10.5376 11.593 13.4614 11.593 16.235 12.345C16.536 12.4277 16.8583 12.3651 17.1065 12.1758C17.3547 11.9865 17.5002 11.6921 17.5 11.38V9.465C17.5 9.02826 17.2166 8.64203 16.8 8.51102C13.674 7.53799 10.326 7.53799 7.2 8.51102Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.333c1cd6.svg";
export { ForwardRef as ReactComponent };